import React, { useEffect, useState } from 'react'
import { Modal, Button, Form, Input, message, DatePicker, Row, Col, Select, ConfigProvider, Spin } from 'antd';
import 'antd/dist/antd.css';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import axios from 'axios';
import api from '../../../services/api';
import * as ModalStatusAction from '../../../redux/actions/modalStatus'
import locale from 'antd/lib/locale/pt_BR';
import moment from 'moment';
import MaskedInput  from 'react-input-mask';
import { municipioService } from '../../../services/Municipios-Service/municipios-service';
import { loginService } from '../../../services/Login-Service/login-service';

interface ModalNovoFeriadoProps {
    modalStatus?: any,
    setNovoFeriadoModal?: any
}

const ModalNovoFeriado: React.FC<ModalNovoFeriadoProps> = (prop) => {

    let visible = prop.modalStatus[0].visibleNovoFeriado
    const [form] = Form.useForm();
    const [loading, setLoading] = useState(false);
    const { Option } = Select;
    const [municipios, setMunicipios] = useState<any>();
    const [ehTipoMunicipal, setEhTipoMunicipal] = useState(null)
    const { TextArea } = Input;
    let tipoFeriados: any[] = [];
    const [tipoFeriadoInput, setTipoFeriadoInput] = useState<any[]>();

    useEffect(() => {
        api.get(`Feriado/gettipoferiado`).then((response) => {
            tipoFeriados = response.data;
            setTipoFeriadoInput(tipoFeriados)
        })
        municipioService.getMunicipio().then((resp)=>{
            setMunicipios(resp.data)
        })
        form.resetFields();
    }, [visible])

    const handleCancel = () => {
        prop.setNovoFeriadoModal(false)
    };

    function toISOFormat(dateTimeString: string) {
        // Primeiro, dividimos a data completa em duas partes:
        const [DD, MM, YYYY] = dateTimeString.split('/');
        // Retornamos a data formatada em um padrão compatível com ISO:
        return `${YYYY}-${MM}-${DD}`;
    }

    const handleOption = (value:any)=>{
        setEhTipoMunicipal(value)
    }

    const validarData = (_: any, value: { number: number }) => {
        let result, data;
        let dataFormatada = toISOFormat(form.getFieldValue("dataInicio"));
        data = new Date(dataFormatada);
        result = moment(data).isValid();
        if (result == false) {
            return Promise.reject(new Error('Data inválida!'));
        }
        return Promise.resolve();
    };

    const onFinish = (values: any) => {
        setLoading(true)
        let dataInicio;

        if (values.dataInicio != undefined) {
            let dataFormatada = toISOFormat(values.dataInicio);
            dataInicio = new Date(dataFormatada);
        }  
        if(values.tipo == "Nacional" || values.tipo == "Estadual"){
            values.municipiodID = null;
        }
        api.post(`Feriado`, {
            FeriadoID: undefined,
            Nome: values.nome,
            Descricao: values.descricao,
            DataInicio: dataInicio,
            Tipo: values.tipo,
            Fixo: values.fixo == "true" ? true : false,
            Ativo: true,
            MunicipioID: values.municipio
        })
            .finally(()=> {
                setLoading(false);
            })
            .then((response) => {
                if (response.data.valido) {
                    prop.setNovoFeriadoModal(false);
                    message.success('Feriado salvo com sucesso')
                    setLoading(false);
                }
                else {
                    message.error(response.data.error,10)               
                }
            })
            .catch((err) => {
                message.error('Falha na requisição')              
            });
            
       
    };


    return (
        <Modal
            visible={visible}
            title="Novo Feriado"
            onCancel={handleCancel}
            footer={null}
        >
            <Spin spinning={loading}>
            <Form
                name="basic"
                form={form}
                onFinish={onFinish}
            >
                <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
                    <Col className="gutter-row" span={24}>
                        <Form.Item
                            label="Nome"
                            name="nome"
                            rules={[
                                {
                                    required: true,
                                    message: 'Por favor insira um nome!',
                                }
                            ]}
                        >
                            <Input placeholder="Digite o Nome do Feriado" />
                        </Form.Item>
                    </Col>
                </Row>
                <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
                    <Col className="gutter-row" span={24}>
                        <Form.Item
                            label="Descrição"
                            name="descricao"
                            rules={[
                                {
                                    required: true,
                                    message: 'Por favor insira a descrição!',
                                }
                            ]}

                        >
                            <TextArea placeholder="DIGITE A DESCRIÇÃO" rows={4}></TextArea>
                        </Form.Item>
                    </Col>
                </Row>
                <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
                    <Col className="gutter-row" span={12}>
                        <Form.Item
                            label="Data"
                            name="dataInicio"
                            rules={[
                                {
                                    required: true,
                                    message: 'Por favor insira a data!',
                                    validator: validarData
                                }
                            ]}
                        >
                            <MaskedInput className="ant-input" placeholder="Informe a Data" mask="99/99/9999" />
                            {/* <DatePicker placeholder="Informe a Data do Feriado" format="DD/MM/YYYY" /> */}
                        </Form.Item>
                    </Col>
                    <Col className="gutter-row" span={12}>
                        <Form.Item
                            label="Fixo"
                            name="fixo"
                            rules={[
                                {
                                    required: true,
                                    message: 'Por favor selecione!',
                                }
                            ]}
                        >
                            <Select placeholder="Fixo">
                                <Option value="true">Sim</Option>
                                <Option value="false">Não</Option>
                            </Select>
                        </Form.Item>
                    </Col>
                </Row>
                <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
                    <Col className="gutter-row" span={24}>
                        <Form.Item
                            label="Tipo"
                            name="tipo"
                            rules={[
                                {
                                    required: true,
                                    message: 'Por favor selecione!',
                                }
                            ]}
                        >
                            <Select onChange={handleOption} placeholder="Tipo">
                                {tipoFeriadoInput?.map(tipo => (
                                    <Option value={tipo.enum}>{tipo.enum}</Option>
                                ))}
                            </Select>
                        </Form.Item>
                    </Col>

                </Row>
                {ehTipoMunicipal == "Municipal"? 
                <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
                    <Col className="gutter-row" span={24}>
                        <Form.Item
                            label="Município"
                            name="municipio"
                            rules={[
                                {
                                    required: true,
                                    message: 'Por favor selecione!',
                                }
                            ]}
                        >
                            <Select placeholder="Informe o município do feriado" showSearch
                            filterOption={(input: any, option: any) => {
                                return (option?.children ?? '').toLowerCase().includes(input.toLowerCase())
                            }}
                            >
                                {loginService.ehTecnicoMunicipal(sessionStorage.getItem('grupoID') || "") ? 
                                    <>
                                    <Select.Option  value={municipios.municipioID}>{municipios.nome}</Select.Option>
                                    </>                                    
                                :
                                 municipios?.map((value:any, index:number)=>
                                    <Select.Option key={index} value={value.municipioID}>{value.nome}</Select.Option>
                                    )
                                }
                            </Select>
                        </Form.Item>
                    </Col>

                </Row>
                :null}

                <Form.Item>
                    <Button className="button-pre-cadastro" type="primary" htmlType="submit">
                        Finalizar
                    </Button>
                </Form.Item>
            </Form>            
                
            </Spin>
        </Modal >
    );
}

const mapStateToProps = (state: any) => ({
    modalStatus: state.modalStatus,
})

const mapDispatcToProps = (dispatch: any) => bindActionCreators(ModalStatusAction, dispatch)

export default connect(mapStateToProps, mapDispatcToProps)(ModalNovoFeriado);